function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9991 3.01915C12.3791 1.47915 10.2691 0.729153 8.16913 0.759153C6.05913 0.789153 3.96913 1.59915 2.37913 3.19915L2.25912 3.31915C0.759123 4.88915 0.0291235 6.91915 0.0491233 8.92915C0.0791232 10.9392 0.869126 12.9491 2.41913 14.4791C19.7091 31.7591 36.7091 49.6292 53.7891 67.1492C53.8391 67.2192 53.8991 67.2892 53.9591 67.3592C55.5891 68.9092 57.7191 69.6692 59.8291 69.6392C61.9391 69.6092 64.0391 68.7892 65.6291 67.1892C82.5791 49.6892 99.4691 32.1192 116.399 14.5892L116.529 14.4692C118.069 12.9392 118.849 10.9392 118.879 8.92916C118.909 6.91916 118.179 4.89916 116.669 3.31916L116.519 3.16916C114.939 1.59916 112.859 0.789162 110.759 0.759162C108.659 0.729162 106.539 1.48916 104.909 3.03916L59.6691 50.2192L13.9991 3.01915Z",
  fill: "black"
});

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 70,
    viewBox: "0 0 119 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.66f76a96.svg";
export { ForwardRef as ReactComponent };